module.exports = __webpack_public_path__ + "static/media/baru.f0ba60e3.PNG";